export default "__VITE_ASSET__KsfG9Ivb__"